'use client';

import React from 'react';
import { ThemeContexts } from '~/contexts';

export const useTheme = () => {
  return React.useContext(ThemeContexts);
};
